<template>
  <div class="plv-ia-pre-redpacket-send-success">
    <img src="../images/pre-redpacket-success.png" alt=""/>
    <h1 class="plv-ia-pre-redpacket-send-success-msg"> {{ t('plvIA.redpacket.sendSuccess') }}</h1>
    <div class="plv-ia-pre-redpacket-send-success-btn-group">
      <button class="plv-ia-pre-redpacket-detail-btn--confirm plv-ia-pre-redpacket-btn-group-btn" @click="$emit('change-current-step', step.preRedpacket)"> {{ t('plvIA.redpacket.btnBack') }} </button>
    </div>
  </div>
</template>

<script>
import { step } from '../config';
import Locale from '@/mixins/locale';
export default {
  name: 'send-success',
  mixins: [Locale],
  data() {
    return {
      step: step
    };
  }
};
</script>

<style lang="scss">
.plv-ia-pre-redpacket-send-success {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-top: 40px;
  img {
    width: 116px;
    height: 116px;
  }
  .plv-ia-pre-redpacket-send-success-msg {
    margin: 0;
    font-size: 18px;
    color: #333;
  }
  .plv-ia-pre-redpacket-btn-group-btn {
    height: 32px;
    line-height: 32px;
    padding: 0 20px;
    background: #2196f3;
    font-size: 14px;
    color: #ffffff;
    border-radius: 18px;
    border: none;
    outline: none;
    cursor: pointer;
    min-width: 96px;
  }
  .plv-ia-pre-redpacket-detail-btn--back {
    border: 1px solid #2196F3;
    background: #ffffff;
    color: #2196F3;
    margin-right: 24px;
  }
  .plv-ia-pre-redpacket-detail-btn--confirm {
    border: 0;
  }
  .plv-ia-pre-redpacket-send-success-btn-group {
    margin-top: 50px;
  }
}
</style>
